import { createTheme } from "@mui/material";

const theme = createTheme({
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiChip: {
      clickable: false,
    },
  },
  palette: {
    primary: {
      light: "#f9d4d4",
      main: "#ff5b5b",
      dark: "#cc4848",
    },
    error: {
      main: "#ff5252",
    },
  },
  typography: {
    fontFamily: "inherit",
    h1: {
      fontSize: "60px",
      fontWeight: 300,
    },
    h2: {
      fontSize: "48px",
      fontWeight: 400,
    },
    h3: {
      fontSize: "34px",
      fontWeight: 500,
    },
    h4: {
      fontSize: "24px",
      fontWeight: 500,
    },
    h5: {
      fontSize: "20px",
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: "17px",
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: "15px",
      fontWeight: 500,
    },
    body1: {
      fontSize: "17px",
      fontWeight: 400,
    },
    body2: {
      fontSize: "15px",
      fontWeight: 400,
    },
    caption: {
      fontSize: "11px",
      fontWeight: 400,
      lineHeight: "auto",
    },
  },
  overrides: {
    MuiContainer: {
      root: {
        paddingLeft: "16px !important",
        paddingRight: "16px !important",
      },
    },
    MuiButton: {
      root: {
        fontSize: "15px",
        lineHeight: "auto",
        textTransform: "initial",
        borderRadius: "20px",
        padding: "11px 14px",
        minWidth: "114px",
        "&.sizeSmall": {
          borderRadius: "16px",
          padding: "6px 14px",
          minWidth: "72px",
        },
      },
      containedPrimary: {
        "&:hover": {
          backgroundColor: "#ff5b5b !important",
        },
        "&:active": {
          backgroundColor: "#cc4848 !important",
        },
        "&:disabled": {
          color: "#fff !important",
          backgroundColor: "#d2d2d3 !important",
        },
      },
      containedSecondary: {
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.3) !important",
        },
        "&:active": {
          backgroundColor: "rgba(255, 255, 255, 0.1) !important",
        },
        "&:disabled": {
          color: "#fff !important",
          backgroundColor: "#d2d2d3 !important",
        },
      },
    },
    MuiIconButton: {
      root: {
        color: "#fff",
      },
      colorSecondary: {
        color: "rgba(255, 255, 255, 0.3)",
      },
    },
    MuiCircularProgress: {
      colorSecondary: {
        color: "#fff",
      },
    },
    MuiChip: {
      root: {
        color: "#d2d2d3",
        backgroundColor: "rgba(255, 255, 255, 0.05)",
      },
      label: {
        overflow: "visible",
        fontSize: "15px",
        padding: "0 20px !important",
      },
    },
  },
});

export default theme;
